// extracted by mini-css-extract-plugin
export default {"next_post":"PostCarousel_next_post__Wae-k","prev_post":"PostCarousel_prev_post__O+JP0"};